import { render } from "./AboutViewTV.vue?vue&type=template&id=00d3bd4a&scoped=true"
import script from "./AboutViewTV.vue?vue&type=script&lang=js"
export * from "./AboutViewTV.vue?vue&type=script&lang=js"

import "./AboutViewTV.vue?vue&type=style&index=0&id=00d3bd4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d3bd4a"]])

export default __exports__